import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Hero3 from '../../components/hero3/hero3'
import CaseStudyHero from '../../components/hero3/casestudyhero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import casestudy from '../../images/casestudy.png'
import casestudy1 from '../../images/casestudy1.png'
import casestudy2 from '../../images/casestudy2.png'
import casestudy3 from '../../images/casestudy3.png'
import casestudy4 from '../../images/casestudy4.png'
import casestudy5 from '../../images/casestudy5.png'
import casestudy6 from '../../images/casestudy6.png'
import casestudy7 from '../../images/casestudy7.png'
import casestudy8 from '../../images/casestudy8.png'
import casestudy9 from '../../images/casestudy9.png'
import { Link } from 'react-router-dom'

const CaseStudy = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <CaseStudyHero top_title={<>Your Shortcut to, <br/> Everything</>} top_desp={<>A collection of powerful productivity tools all within an <br/> extendable launcher. Fast, ergonomic and reliable.</>} />

                    <section className="intro_about_section section_space">
                        <div className="container">
                             
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                        <Row>
                                            <Col sm={4}>
                                                <div className="megamenu_pages_wrapper">
                                                    <h3 className="megamenu_info_title mb-0">Select Category</h3>
                                                </div>
                                                <Nav variant="pills" className="flex-column casestudy_nav" >
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="first">All</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="second">Software Development</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="thired">Mobile App</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="fourth">Web App</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="fifth">Modernization</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="sixth">DevOps</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Col>
                                            <Col sm={8} style={{paddingTop:'0px'}}>
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="first">
                                                        <div className='row' style={{margin:'0px'}}>
                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy1} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Reviving SEO & Building AI Visibility for a Plate Heat Exchanger Manufacturer</h3>
                                                                       <Link to="/srj">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link> 
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy2} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Global Expansion & Growth for Aroma Monk</h3>
                                                                        <Link to="/aromamonk">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy3} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>B2B Pharma SEO Turnaround for a Private-Label Manufacturer</h3>
                                                                        <Link to="/elise">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy4} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Export-Ready Website & AI-First SEO for GNC Exports</h3>
                                                                        <Link to="/gnc">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy5} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Organic Growth & CAC Reduction for Ease My Hotel (SaaS)</h3>
                                                                        <Link to="/easemyhotel">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy6} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Dual-Sided Growth for a SaaS Influencer Marketing Platform (US)</h3>
                                                                        <Link to="/nicolas">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy7} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Global Expansion & Export Lead Growth for Farmoduct (Agri Exports)</h3>
                                                                        <Link to="/farmoduct">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy8} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Local & B2B SEO Expansion for a Singapore Kitchen Cabinet Brand</h3>
                                                                        <Link to="/george">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='case_study_item'>
                                                                    <div className='case_study_img'>
                                                                        <img src={casestudy9} alt='casestudy' />
                                                                    </div>
                                                                    <div className='case_study_content'>
                                                                        <h3>Local Authority & Year-Round Lead Growth for Arrow Gifter (Corporate Gifting)</h3>
                                                                        <Link to="/arrowdifter">Learn More &nbsp;&nbsp; <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>                                                                    
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            
                                                        </div>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                
                        </div>
                    </section>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default CaseStudy;
